<div class="paginator-container">
    @if (includeDivider()) {
        <p-divider></p-divider>
    }

    <nav aria-label="uiKit.miscs.paginator.ariaLabel">
        <p-paginator
            [id]="id() + '-paginator'"
            [first]="pagination().skip"
            [rows]="pagination().take"
            [totalRecords]="totalCount()"
            [templateLeft]="numberOfItems"
            [templateRight]="pageSize"
            [attr.aria-current]="'page'"
            (onPageChange)="changePage($event)"></p-paginator>
    </nav>

    <ng-template #numberOfItems>
        <div>
            {{ 'uiKit.miscs.paginator.total' | translate }} {{ totalCount() }}
            {{ (totalCount() === 1 ? 'uiKit.miscs.paginator.item' : 'uiKit.miscs.paginator.items') | translate }}
        </div>
    </ng-template>

    <ng-template #pageSize>
        @if (pageSizeOptions().length) {
            <div>
                <dropdown
                    [id]="'paginator'"
                    [(value)]="pagination().take"
                    [options]="pageSizeOptions()"
                    [optionLabel]="undefined"
                    [optionValue]="undefined"
                    [showClear]="false"
                    [filter]="false"
                    (valueChange)="changePageSize()"></dropdown>
            </div>
        }
    </ng-template>
</div>
